module.exports = __webpack_public_path__ + "img/arrow.935e4cc8.svg";